<app-message></app-message>
<app-loader></app-loader>
<router-outlet></router-outlet>